import * as React from 'react';

import { UIHeading1, UIHeading2, UIHeading3, UIText1, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as style from './styles.css';
import { IconProductGift16 } from '@cian/ui-kit-design-tokens/icons';

import bannerImg from './assets/banner.png';
import { IApplicationContext } from '../../../common/types/applicationContext';
import { getHowItGarantWork } from './constants';

export interface IHowWorkGarantProps {
  context: IApplicationContext['custom'];
}

export const HowWorkGarant: React.FC<IHowWorkGarantProps> = ({ context }) => {
  const device = useDeviceType();
  const isMobile = device === 'phone';

  const items = getHowItGarantWork(context);

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['heading']}>
        <div className={style['heading-title']}>Как&nbsp;работает защита права собственности на&nbsp;покупку</div>

        <div className={style['label']}>
          <IconProductGift16 color="accent-positive-primary" />
          <UIText1 color="text-positive-default">Бесплатно если продаете и покупаете вместе с нами</UIText1>
        </div>
      </div>

      <div className={style['wrapper']}>
        <div>
          {items.map(({ icon, title, descr, button }, index) => (
            <div key={title + index} className={style['item']}>
              <div className={style['icon']}>
                <img src={icon} alt={title} />
              </div>
              <div className={style['title']}>
                {isMobile ? (
                  <UIHeading2 color="text-primary-default">{title}</UIHeading2>
                ) : (
                  <UIHeading1 color="text-primary-default">{title}</UIHeading1>
                )}
              </div>

              <div className={style['descr']}>
                {isMobile ? (
                  <UIText1 color="text-primary-default">{descr}</UIText1>
                ) : (
                  <UIHeading3 color="text-primary-default">{descr}</UIHeading3>
                )}
              </div>

              <div className={style['button']}>{button}</div>
            </div>
          ))}
        </div>

        {!isMobile && (
          <div className={style['banner']}>
            <img src={bannerImg} alt="" />
          </div>
        )}
      </div>
    </div>
  );
};
